import { Avatar } from '@unified-checkout/design-system';
import { getUserData } from '../../utils';
import { useIsUser } from '../../hooks';
interface IUserInfoProps {
  isSideMenuCollapsed?: boolean;
}
export const UserInfo = ({ isSideMenuCollapsed }: IUserInfoProps) => {
  const {userData} = useIsUser()
  const { fullName, email, phone } = userData || {};

  const [firstname, lastname] = fullName?.split(' ') || []
  const firstCharacters = ((firstname?.charAt(0) + lastname
    ?.charAt(0))||''
    ).replace(/undefined/ig,'')?.toUpperCase()
  if (!userData) return null;
  return (
    <section className="[&_p]:truncate">
      {!!firstCharacters && (
        <Avatar
          size="2xl"
          shortName={firstCharacters}
          type="text"
          focusable={false}
        />
      )}
      {!isSideMenuCollapsed && (
        <>
          {fullName && (
            <p className="mt-3 text-gray-700 english-heading-compact-semibold">
              {fullName}
            </p>
          )}
          {email && (
            <p className="text-gray-500 english-utility-helper-text-regular">
              {email}
            </p>
          )}
          {phone && (
            <p className="text-gray-500 english-utility-helper-text-regular">
              {phone}
            </p>
          )}
        </>
      )}
    </section>
  );
};
